import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { routes } from '../../constants/routes'
import { isEmpty } from 'lodash'

// pages where a chef is signing in or creating an account
const CHEF_AUTH_PATHS = [
    routes.authLogin.path,
    routes.authRegister.path,
    routes.authPasswordHelp.path,
    routes.authPasswordReset.path,
    routes.authHandler.path
]

const PublicNav = ({ auth, user }) => {
    const { pathname } = useLocation()
    const isSignedIn = auth && !isEmpty(auth)
    const roleLevel = user && '_computed' in user ? user._computed.roleLevel : 0
    const isChefAuthPage = CHEF_AUTH_PATHS.includes(pathname)

    return (
        <div id="public-nav">
            <div className="logo">
                <Link to={routes.publicIndex.path}>
                    <img src="/img/icons/tivity-logo.png" alt="Tivity Logo" height="90" />
                </Link>
            </div>
            <div className="public-menu">
                {isSignedIn && roleLevel >= 1000 &&
                    <NavLink to={routes.adminIndex.path}>Admin</NavLink>
                }
                {isSignedIn && roleLevel >= 500 &&
                    <NavLink to={routes.chefPortalIndex.path}>Chef Portal</NavLink>
                }
                {isSignedIn && <NavLink to={routes.authLogout.path}>Logout</NavLink>}
                {!isSignedIn && isChefAuthPage &&
                    <>
                        <NavLink to={routes.authRegister.path}>Register</NavLink>
                        <NavLink to={routes.authLogin.path}>Login</NavLink>
                    </>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user
    }
}

export default connect(mapStateToProps)(PublicNav)
